import { useOutletContext } from "react-router-dom";

import { InsightsAsset } from "graphql-types/graphql";

import { BuildingDataTab } from "./tabs";

export const Overview = () => {
    const { asset } = useOutletContext<{ asset: InsightsAsset }>();

    return <BuildingDataTab asset={asset} />;
};
